export enum StatusConexaoEnum {
    Desconectado = 1,
    Conectando = 2,
    Conectado = 3,
    Falha = 4
}
